import { LocalCanal, LocalCanalForm } from '@models/.';

export function transformToData(localChannel: LocalCanal | null): LocalCanal | null {
  if (!localChannel) return null;
  
  return {
    ...localChannel,
  };
}

export function transformToForm(localChannel: LocalCanalForm | null): LocalCanalForm | null {
  if (!localChannel) return null;
  
  return {
    ...localChannel,
  };
}


export function transformToName(localChannels: LocalCanal[]): string[] {

  return localChannels.map((channel) => channel.name)
}